import { useCmmdForgeRuntimeListSnapshot } from "../cmmd/cmmdForgeRuntimeListResource";
import { forgeCloudEnvironmentLabelForRow } from "./forgeCloudEnvironmentLabel";
import { useForgeCloudEnvironmentNamingContext } from "./useForgeCloudEnvironmentNamingContext";

/**
 * The label of the Environment a Runtime id belongs to, or null when the
 * catalog does not list it.
 *
 * For a surface that holds only a Runtime id, such as the in-thread panel that
 * offers "Update Forge". It reads the same label Connections shows, so the two
 * cannot name one Environment differently.
 */
export function useForgeCloudEnvironmentLabelForRuntime(runtimeId: string | null): string | null {
  const { environments } = useCmmdForgeRuntimeListSnapshot();
  const namingContext = useForgeCloudEnvironmentNamingContext();
  const environment = environments.find((row) => row.runtimeId === runtimeId) ?? null;
  return environment === null ? null : forgeCloudEnvironmentLabelForRow(environment, namingContext);
}
